import { Component } from "react";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";

export class LeadsSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
      },
      openDrawer: false,
    };
    this.newLeadfields = [
      {
        name: "startDate",
        label: "Start Date",
        type: "date",
        placeholder: "Start Date",
      },
      {
        name: "endDate",
        label: "End Date",
        type: "text",
        type: "date",
        placeholder: "End Date",
      },
      {
        label: "Source",
        name: "source",
        type: "select",
        options: _enum.SOURCES,
        placeholder: "Please Enter",
      },
    ];
    this.assignedtofields = [
      {
        name: "telecaller",
        label: "Tele Callers",
        type: "select",
        options: [],
        placeholder: "Tele Callers",
      },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.OPS_LEADS_STATUS,
        placeholder: "Status",
      },
      {
        name: "startDate",
        label: "Start Date",
        type: "date",
        placeholder: "Start Date",
      },
      {
        name: "endDate",
        label: "End Date",
        type: "text",
        type: "date",
        placeholder: "End Date",
      },
      {
        label: "Source",
        name: "source",
        type: "select",
        options: _enum.SOURCES,
        placeholder: "Please Enter",
      },
    ];
    this.isAdmin = this.props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
  }

  componentDidMount() {
    this.getAllTelecallers();
  }

  getAllTelecallers = () => {
    this.props.apis
      .apiGetAllEmployees({ role: _enum.ROUTE_PERSONAS.telecaller })
      .then(({ data, total }) => {
        let telecaller = this.assignedtofields.find(
          (o) => o.name == "telecaller"
        );
        telecaller.options = data.options("employee_id", "full_name");
      });
  };

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { activeKey } = this.props;
    let { openDrawer } = this.state;
    return (
      <div className="d-flex align-items-center justify-content-end">
        <button
          type="button"
          className="btn filter_modal_btn"
          onClick={(...args) => this.toggleDrawer(...args)}
        >
          <i class="fa-solid fa-filter me-2"></i>
          <span>Filters</span>
        </button>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          {...(activeKey === _enum.ROUTE_PERSONAS.telecaller
            ? { fields: this.assignedtofields }
            : { fields: this.newLeadfields })}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(LeadsSearch);
